import http from './http';

export function articlePublicList({ address, pageNum = 1, pageSize = 10, w = '' } = {}) {
  return http.postJson('/article/public/list', {
    address,
    pageNum,
    pageSize,
    w
  });
}

export function articleFollowList({ address, pageNum = 1, pageSize = 10 } = {}) {
  return http.postJson('/article/follow/list', {
    address,
    pageNum,
    pageSize
  });
}

export function articleCollectList({ address, pageNum = 1, pageSize = 5 } = {}) {
  return http.postJson('/article/collect/list', {
    address,
    pageNum,
    pageSize
  });
}

export function articleMyList({ address, pageNum = 1, pageSize = 10, queryHighLike = 0 } = {}) {
  return http.postJson('/article/my/list', {
    address,
    pageNum,
    pageSize,
    queryHighLike
  });
}

export function articleDetail({ address, articleId }) {
  return http.postJson('/article/detail', {
    address,
    articleId
  });
}

export function v1NewsList({ address, pageNum = 1, pageSize = 30 } = {}) {
  return http.postJson('/v1/news/list', {
    address,
    pageNum,
    pageSize
  });
}

export function articleLike({ address, articleId, add }) {
  return http.postJson('/article/like', {
    address,
    articleId,
    add
  });
}

export function userinfoFollow({ address, followedUid, add }) {
  return http.postJson('/userinfo/follow', {
    address,
    followedUid,
    add
  });
}

export function articleComplaint({ address, articleId, reason = '', content = '' }) {
  return http.postJson('/article/complaint', {
    address,
    articleId,
    reason,
    content
  });
}
